import React, { Component } from "react";
import { connect } from "dva";
import { Spin } from "antd";
import Norm from "../../components/NormComponent";
import Self from "../../components/SelfComponent";
import TreeList from "../../components/TreeList";
import styles from "./evaluationSelfTree.less";

@connect(({ tree, self }) => ({
  projectId: self.currentProjectId,
  indexId: tree.selectTreeNodeKey[1],
  index: self.index,
  selfEvaluation: self.selfEvaluation,
  templateType: self.templateType,
  currentselectTreeNode: tree.currentselectTreeNode,
  selectTreeNodeKey: tree.selectTreeNodeKey,
  spinProps: self.spinProps
}))
class EvaluationSelfTree extends Component {
  constructor(props) {
    super(props);
    const { currentselectTreeNode, org } = props;
    const { type = 1, code = "" } = currentselectTreeNode;
    this.state = {
      selectNormType: org ? 1 : type, // org是用来识别是否是个性化指标的，父组件传进来的
      reRender: false,
      code,
      showTree: false
    };
  }

  componentDidMount() {
    const {
      location: { query }
    } = this.props;
    const { currentProjectId, nowOrgId } = query;
    this.nowOrgId = nowOrgId;
    this.saveState({
      currentProjectId
    });
    this.getData(currentProjectId);
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "self/reset"
    });
    dispatch({
      type: "tree/reset"
    });
  }

  saveState = payload => {
    const { dispatch } = this.props;
    dispatch({
      type: "self/save",
      payload
    });
  };

  getData = id => {
    // 调接口
    const { code, selectNormType } = this.state;
    this.getTree(id);
    if (code && selectNormType === 2) {
      this.getDetail(code, id);
    }
  };

  getTree = id => {
    const { dispatch, org } = this.props;
    dispatch({
      type: "tree/fetchSelfTree",
      payload: {
        projectId: id,
        orgId: this.nowOrgId,
        org: org || false // org是用来识别是否是个性化指标的，父组件传进来的
      },
      callback: () => {
        this.setState({
          showTree: true
        });
      }
    });
  };

  getDetail = (code, id) => {
    const { dispatch, index, projectId, org } = this.props;
    const { id: indexId } = index;
    dispatch({
      type: "self/fetchTreeDetail",
      payload: {
        indexId: code || indexId,
        projectId: projectId || id,
        orgId: this.nowOrgId,
        org: org || false // org是用来识别是否是个性化指标的，父组件传进来的
      },
      callback: () => {
        this.setState({
          reRender: true
        });
      }
    });
  };

  handleChangeSelect = ({ type, code }) => {
    this.setState(
      {
        selectNormType: type,
        reRender: false
      },
      () => {
        if (type === 2) {
          this.getDetail(code);
        }
      }
    );
  };

  render() {
    const { selectNormType, reRender, showTree } = this.state;
    const { index, selfEvaluation, templateType = 1, spinProps } = this.props;
    const normProps = {
      formType: "detail",
      templateType,
      reRender,
      from: "self",
      ...index
    };
    if (window.document.getElementById("right-side-self-tree")) {
      window.document.getElementById("right-side-self-tree").scrollTop = 0;
    }
    return (
      <div className={styles.myTree}>
        <Spin {...spinProps} wrapperClassName="myselfTreeSpin">
          <div className="container">
            <div className="norm-wrap">
              <div className="left-side">
                <div className="leftSideContainer">
                  {showTree && (
                    <TreeList
                      onSelect={this.handleChangeSelect}
                      needRememberNowNode={0}
                      expandAllTree
                    />
                  )}
                </div>
              </div>
              <div className="right-side" id="right-side-self-tree">
                {selectNormType === 2 && (
                  <div className="rightSideContainer">
                    <Norm {...normProps} />
                    <Self
                      formType="detail"
                      templateType={templateType}
                      from="evaluate"
                      reRender={reRender}
                      {...selfEvaluation}
                      callback={this.getDetail}
                      noNeedUpdate
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Spin>
      </div>
    );
  }
}

export default EvaluationSelfTree;
